import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'walk-in-interests',
  onEnter: isLoggedIn(store),
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const CustomerInterest = require('./containers/WalkInInterestsContainer').default
      const {walkInInterestsFilterReducer, walkInInterestsReducer, selectedValuesReducer, walkInInterestFormReducer} = require('./modules/walkInInterests')
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics');

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'walkInInterestsFilter', reducer: walkInInterestsFilterReducer})
      injectReducer(store, {key: 'walkInInterests', reducer: walkInInterestsReducer})
      injectReducer(store, {key: 'walkInInterestForm', reducer: walkInInterestFormReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})
      injectReducer(store, {key: 'walkInInterestColumns', reducer: selectedValuesReducer})


      /*  Return getComponent   */
      cb(null, CustomerInterest)

      /* Webpack named bundle   */
    }, 'HomeView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/WalkInInterests/index.js